<div class="filter-dialog ">
  <div class="dialog-container">
    <h2 mat-dialog-title style="padding-left: 16px;">{{ 'FILTER.TITLE' | translate }}</h2>
    <mat-dialog-content>
      <div class="row">
        <div class="col-sm-12">

          @for (filter of filters; track filter.id; let i = $index) {
          <div class="row">
            <div class="col-sm-6">
              <div class="mat-form-field padding-top-16">
                <mat-form-field appearance="outline" class="full-width form-fields">
                  <mat-label class="field-label">{{ 'FILTER.SELECT_COLUMN' | translate }}</mat-label>
                  <mat-select (selectionChange)="updateFilter(filter.id, 'column', $event.value)"panelClass="dropdown-panel"
                    [value]="filter.column">
                    <mat-option *ngFor="let column of availableColumns" [value]="column.id">{{ column.label | translate
                      }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-6" *ngIf="filter.column">
              <div class="mat-form-field padding-top-16">
                <mat-form-field appearance="outline" class="full-width form-fields">
                  <mat-label class="field-label">{{ 'FILTER.OPERATOR' | translate }}</mat-label>
                  <mat-select [value]="filter.operator"
                    (selectionChange)="updateFilter(filter.id, 'operator', $event.value)" panelClass="dropdown-panel">
                    <mat-option *ngFor="let op of getOperatorsForColumn(filter.column)" [value]="op.value">{{ op.label | translate
                      }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-6" *ngIf="filter.operator">
              <!-- Enum Dropdown -->
              <div class="mat-form-field padding-top-16" *ngIf="getColumnType(filter.column) === 'enum'">
                <mat-form-field appearance="outline" class="full-width form-fields">
                  <mat-label class="field-label">{{ (needsTwoInputs(filter.operator) ? 'FILTER.VALUE_FROM' : 'FILTER.VALUE') | translate }}</mat-label>
                  <mat-select [value]="filter.value" (selectionChange)="updateFilter(filter.id, 'value', $event.value)" panelClass="dropdown-panel">
                    <mat-option *ngFor="let val of getColumnValues(filter.column)" [value]="val">{{ getLocalizedFilterOption(val, filter.column) }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- Multi Select Dropdown -->
              <div class="mat-form-field padding-top-16" *ngIf="getColumnType(filter.column) === 'multiSelect'">
                <mat-form-field appearance="outline" class="full-width form-fields">
                  <mat-label class="field-label">{{ (needsTwoInputs(filter.operator) ? 'FILTER.VALUE_FROM' : 'FILTER.VALUE') | translate }}</mat-label>
                  <mat-select multiple [value]="filter.value" (selectionChange)="updateFilter(filter.id, 'value', $event.value)" panelClass="dropdown-panel">
                    <mat-option *ngFor="let val of getColumnValues(filter.column)" [value]="val">{{ getLocalizedFilterOption(val, filter.column) }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- Number Input -->
              <div class="mat-form-field padding-top-16" *ngIf="getColumnType(filter.column) === 'number'">
                <mat-form-field appearance="outline" class="full-width form-fields" subscriptSizing="dynamic"  floatLabel="always">
                  <mat-label class="field-label">{{ 'FILTER.NUMBER_VALUE' | translate }}</mat-label>
                  <input matInput type="number" [value]="filter.value"
                    (input)="updateFilter(filter.id, 'value', $any($event.target).value)"
                    [placeholder]="'FILTER.ENTER_NUMBER_VALUE' | translate" />
                </mat-form-field>
              </div>

              <!-- Date Input -->
              <div class="mat-form-field padding-top-16" *ngIf="getColumnType(filter.column) === 'date' || getColumnType(filter.column) === 'datetime'">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label class="field-label">{{ 'FILTER.DATE_VALUE' | translate }}</mat-label>
                  <input matInput [value]="filter.value"
                    (dateChange)="updateFilter(filter.id, 'value', $any($event.target).value)"
                    [matDatepicker]="filterDatepicker" readonly />
                  <mat-datepicker-toggle matSuffix [for]="filterDatepicker"></mat-datepicker-toggle>
                  <mat-datepicker #filterDatepicker></mat-datepicker>
                </mat-form-field>
              </div>

              <!-- Text Input -->
              <div class="mat-form-field padding-top-16" *ngIf="getColumnType(filter.column) === 'text'">
                <mat-form-field appearance="outline" class="full-width form-fields" subscriptSizing="dynamic"  floatLabel="always">
                  <mat-label class="field-label">{{ 'FILTER.TEXT' | translate }}</mat-label>
                  <input matInput type="text" [value]="filter.value" [placeholder]="'FILTER.ENTER_TEXT_VALUE' | translate"
                    (input)="updateFilter(filter.id, 'value', $any($event.target).value)" />
                </mat-form-field>
              </div>

              <!-- Second Value Input (for Between operator) -->
              <div class="mat-form-field padding-top-16" *ngIf="needsTwoInputs(filter.operator)">
                <mat-form-field appearance="outline" class="full-width ">
                  <mat-label class="field-label">{{ 'FILTER.VALUE_TO' | translate }}</mat-label>
                  <input matInput [value]="filter.valueTo"
                    (dateChange)="updateFilter(filter.id, 'valueTo', $any($event.target).value)"
                    [placeholder]="'FILTER.ENTER_TO_DATE' | translate" [matDatepicker]="toDatepicker" readonly />
                  <mat-datepicker-toggle matSuffix [for]="toDatepicker"></mat-datepicker-toggle>
                  <mat-datepicker #toDatepicker></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
            <!-- Delete Button -->
            <div class="col-sm-6">
              <button mat-button *ngIf="filters.length > 1" [title]="'FILTER.REMOVE_FILTER' | translate" (click)="removeFilter(filter.id)"
                class="cancel-button" style="margin-top: 16px; margin-bottom: 16px;">
                <svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6h14z" />
                </svg>
              </button>
            </div>
          </div>
          }
          <button mat-raised-button color="primary" (click)="addFilter()" class="save-button"
            style="margin-top: 16px; margin-bottom: 16px;">
            <svg width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 5v14M5 12h14" />
            </svg>
            {{ 'COMMON.BUTTONS.ADD_ANOTHER_FILTER' | translate }}
          </button>
        </div>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button (click)="clearFilters()" class="cancel-button">{{ 'COMMON.BUTTONS.CLEAR_ALL' | translate }}</button>
      <button mat-button (click)="onCancel()" class="cancel-button">{{ 'COMMON.BUTTONS.CANCEL' | translate }}</button>
      <button mat-raised-button color="primary" (click)="applyFilters()" class="save-button">
        {{ 'COMMON.BUTTONS.APPLY' | translate }}
      </button>
    </mat-dialog-actions>
  </div>
</div>
